module.exports = __webpack_public_path__ + "static/media/stemcellnanofillerlipcontour.4e4d42a5.png";